module.exports = __webpack_public_path__ + "img/copy-pay-hero.c90e966a.png";